import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import OrganizationsMultiSelect from "@/components/v2/molecules/admin/tabs/AdminDashboardTab/OrganizationsMultiSelect";
import PropertiesMultiSelect from "@/components/v2/molecules/admin/tabs/AdminDashboardTab/PropertiesMultiSelect";
import DateRangePresetPicker from "@/components/v2/molecules/admin/shared/DateRangePresetPicker";
import { BUSINESS_INCOME_TYPES } from "@/constants/businessIncomes";
import { X, Search } from "lucide-react";

interface BusinessIncomeFiltersProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  selectedOrganizations: string[];
  setSelectedOrganizations: (ids: string[]) => void;
  selectedProperties: string[];
  setSelectedProperties: (ids: string[]) => void;
  selectedIncomeType: string;
  setSelectedIncomeType: (type: string) => void;
  startDate?: Date;
  setStartDate: (date?: Date) => void;
  endDate?: Date;
  setEndDate: (date?: Date) => void;
  organizations: any[];
  filteredPropertiesForCascade: any[];
  hasActiveFilters: boolean;
  clearFilters: () => void;
}

const BusinessIncomeFilters = ({
  searchTerm,
  setSearchTerm,
  selectedOrganizations,
  setSelectedOrganizations,
  selectedProperties,
  setSelectedProperties,
  selectedIncomeType,
  setSelectedIncomeType,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  organizations,
  filteredPropertiesForCascade,
  hasActiveFilters,
  clearFilters,
}: BusinessIncomeFiltersProps) => {
  const handleDateRangeChange = (from: Date | undefined, to: Date | undefined) => {
    setStartDate(from);
    setEndDate(to);
  };

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-4">
        {/* Search Input */}
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            placeholder="Buscar por descripción..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 w-[240px] rounded-full bg-gray-100 hover:bg-gray-200 transition-colors border-0"
          />
        </div>

        <OrganizationsMultiSelect
          organizations={organizations}
          selectedOrganizations={selectedOrganizations}
          onSelectionChange={setSelectedOrganizations}
        />

        <PropertiesMultiSelect
          properties={filteredPropertiesForCascade}
          selectedProperties={selectedProperties}
          onSelectionChange={setSelectedProperties}
        />

        <Select value={selectedIncomeType} onValueChange={setSelectedIncomeType}>
          <SelectTrigger className="w-[200px] rounded-full bg-gray-100 hover:bg-gray-200 transition-colors border-0">
            <SelectValue placeholder="Tipo de ingreso" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los tipos</SelectItem>
            {BUSINESS_INCOME_TYPES.map((type) => (
              <SelectItem key={type} value={type}>
                {type}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-4">
        <DateRangePresetPicker
          dateFrom={startDate}
          dateTo={endDate}
          onDateRangeChange={handleDateRangeChange}
        />
        
        {hasActiveFilters && (
          <Button
            variant="ghost"
            onClick={clearFilters}
            size="icon"
            className="h-10 w-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default BusinessIncomeFilters;
